define('views/modules/member/group/edit/group-edit-form',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // src
    'services/user',
    'services/api',
    //models
    'models/member/group',
    // services
    'services/i18n',
    // views
    'views/parts/form/textbox',
    'views/parts/info-section',
    'views/parts/form/select',
    'views/parts/form/choices',
    'views/parts/form/datepicker',
    'views/parts/tree/tree-view',
    'views/parts/menu/menu-dropdown',
    // templates
    'text!templates/modules/member/group/edit/group-edit-form.html',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // src
    User,
    API,
    //models
    MGroup,
    //services
    i18n,
    // views
    VTextBox,
    VInfoSection,
    VSelect,
    VChoices,
    VDatePicker,
    VTreeView,
    VMenuDropdown,
    // templates
    TGroupEditForm
) {

    var VGroupEditForm = Backbone.View.extend({
        template: TGroupEditForm,

        regions: {
            form: {
                parentGroupLabel: '.parent-group-label',
                name: '.name-input',
                groups: "#group-menu",
            }
        },

        initialize: function(opt) {
            this.selectedGroup = opt.selectedGroup;
            this.options = opt || {};

            var groupTreeView = new VTreeView({
                label: 'name',
                subgroup: 'subgroups',
                activeAttribute: '_menuActive',
                depth: 5,
                toggleActive: true,
                firstOpen: true,
                collection: this.collection
            });

            this.view = {
                info: new VInfoSection({
                    title: "supervisor:member-additionnal-settings",
                    //help: "messages:helpbox-account-settings",
                    content: this.template,
                }),
                form: {
                    name: new VTextBox({ label: 'form-group-name', attribute: 'name', labelposition: "top", model: this.model }),
                    groups: new VMenuDropdown({
                        label: 'form-group-parent-group',
                        context: this,
                        showLabel: false,
                        labelposition: "top",
                        displayManageGroup: false,
                        //treeView: groupTreeView,
                        collection: new Backbone.Collection([
                            { tree: true, tree_only: true, view: groupTreeView }
                        ]),
                    }),
                },
            };

            // groups collection
            this.listenTo(this.collection, {
                'update': this.onGroupCollectionUpdate,
                'click': this.onGroupClick
            });

            this.listenTo(groupTreeView, 'click', this.onSelectGroup);


        },

        render: function() {
            this.selectedGroup = this.model;

            this.$el.empty()
                .append(Mustache.render(this.template, Mustache.getContext({ parentGroupLabel: this.parentGroupLabel })));

            // append the form
            this.assign(this.view.info, this.$el);

            this.collection.fetch({ async: false });

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.form.name, zone.form.$name);

            //Hide the treeview dropdown only for the root Group.
            //They must stay dependent from the 3 "MASTER" group defined in the API.
            if (this.model.isNew() || this.model.isTopLevelFirstGroup() === false) {
                 this.assign(view.form.groups, zone.form.$groups);
                 this.setTreeviewParent();
            } else {
                this.$el.find("#parentGroupLabel").addClass('hidden');
            }

            return this;
        },

        // filterGroupCollection: function() {
        //     for (var i = 0; i < this.collection.length; i++) {
        //         this.collection.models[i].set('subgroups', []);
        //     }
        // },

        setTreeviewParent: function() {
            var parentName = '';

            if (this.model.isNew()) {
                parentName = this.collection.models[0].get('name');
            } else {
                var parent = new MGroup({ _id: this.model.get("parent") });
                parent.fetch({
                    async: false
                });
                parentName = parent.get('name');
            }

            this.view.form.groups.setLabel(parentName);
        },

        //
        // ////////////
        // events //
        ////////////
        onSelectGroup: function(groupModel) {
            var selectedGroup = this.selectedGroup;
            if (groupModel !== undefined && selectedGroup !== groupModel) {
                if (selectedGroup) {
                    selectedGroup.set('_menuActive', false);
                }

                this.selectedGroup = selectedGroup = groupModel;
            }

            this.view.form.groups.setLabel(groupModel.get('name'));
            this.view.form.groups.close();
            selectedGroup.set('_menuActive', true);

            if (this.model.get('parent') !== groupModel.get('_id'))
                this.model.set('parent', groupModel.get('_id'));
        },
    });

    return VGroupEditForm;
});

